import { isFunction, isObject, isString } from 'lodash';

import DefaultExternalAuthProvider from './default.provider';
import InstapaperAuthProvider from './instapaper.provider';
import AdfsProvider from './library.adfs.provider';
import LibraryBaseProvider from './library.base.provider';
import OpenAthensProvider from './library.openathens.provider';
import LibrarySipProvider from './library.sip.provider';
import VidmProvider from './library.vidm.provider';

interface AuthProvider {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    authorize: (args: any) => Promise<any>;
}

const providers: Record<string, AuthProvider> = {};

/**
 * Delegates authorization call to a registered implementation.
 */
function getProvider(provider: string): AuthProvider {
    if (!isString(provider)) {
        throw new TypeError('provider name is not specified');
    }

    const implementation = providers[provider];

    if (implementation === undefined) {
        throw new TypeError(`${provider} provider implementation not registered`);
    }

    return implementation;
}

/**
 * Register a specific implementation of an auth provider.
 */
function registerProvider(provider: string, implementation: AuthProvider): void {
    if (provider === undefined) {
        throw new Error('provider is not specified');
    }

    if (!isString(provider)) {
        throw new TypeError('provider name has to be a string');
    }

    if (!isObject(implementation) || !isFunction(implementation.authorize)) {
        throw new TypeError('provider has to be an object with method "authorize" expected');
    }

    providers[provider] = implementation;
}

export {
    AdfsProvider,
    AuthProvider,
    DefaultExternalAuthProvider,
    getProvider,
    InstapaperAuthProvider,
    LibraryBaseProvider,
    LibrarySipProvider,
    OpenAthensProvider,
    registerProvider,
    VidmProvider,
};
